class CartDrawer extends HTMLElement {
	constructor() {
		super()
		this.body = document.querySelector("body")
		this.cart = document.querySelector(".cart-drawer")
		this.backdrop = document.querySelector(".backdrop")
		this.headerCartButton = document.querySelector(".header_nav-cart")
		this.shippingAssurance = document.querySelector(".cart-drawer-item.shipping-assurance")

		this.init()
	}
	
	async init() {
		let isUpdateCartDrawer = false
		
		if (this.shippingAssurance && this.shippingAssurance.getAttribute("data-cart-shipping-assurance-existing-variants") !== "") {
			const shippingAssuranceExistVariants = this.shippingAssurance.getAttribute("data-cart-shipping-assurance-existing-variants").split(",")
			
			if (shippingAssuranceExistVariants.length > 0) {
				await this.removeShippingAssuranceItem(shippingAssuranceExistVariants)
				isUpdateCartDrawer = true
			}
		}
		
		if (this.carDrawerItemsContainer) {
			this.outOfStockItems = this.carDrawerItemsContainer.getAttribute("data-out-off-stock-items")?.split(",")
			
			if (this.outOfStockItems) {
				isUpdateCartDrawer = true
			}
		}
		
		if (isUpdateCartDrawer) {
			await this.updateCartDrawer()
		} else {
			this.initQuantitySelector()
			this.initShippingAssurance()
			this.setWindowListeners()
			this.setCartListeners()
			this.setHeaderCartButtonListeners()
		}
	}
	
	setWindowListeners() {
		window.addEventListener("cart-update", async () => {
			if (!this.checkOpen()) {
				this.open()
			}
			
			const cartSubtotal = this.cart.querySelector(".cart-drawer_price-count")
			this.initLoader(cartSubtotal)
			
			if (this.shippingAssuranceEnabled && this.shippingAssurance) {
				const shippingAssurancePriceElement = this.shippingAssurance.querySelector(".cart-drawer-item_price")
				this.initLoader(shippingAssurancePriceElement)
			}
			
			await this.updateCartDrawer()
		})
		
		if (window.location.hash.includes("cart=open")) {
			this.open()
		}
	}
	
	setCartListeners() {
		let shippingAssuranceProductAdded = false
		const cartCloseButton = document.querySelector(".cart-drawer_header-close")
		const cartCheckoutButton = document.querySelector(".cart-drawer_button")
		
		cartCloseButton.addEventListener("click", (e) => {
			e.preventDefault()
			this.close()
		})
		
		cartCheckoutButton.addEventListener("click", async (e) => {
			if (!shippingAssuranceProductAdded && this.shippingAssuranceEnabled === "true") {
				e.preventDefault()
				await this.addShippingAssuranceItem()
				shippingAssuranceProductAdded = true
				cartCheckoutButton.click()
			}
		})
		
		this.cart.addEventListener("keyup", (e) => {
			e.preventDefault()
			if (e.code.toUpperCase() === "ESCAPE") {
				this.close()
			}
		})
	}
	
	setHeaderCartButtonListeners() {
		if (!this.headerCartButton.hasAttribute("listened")) {
			this.headerCartButton.addEventListener("click", (e) => {
				e.preventDefault()
				
				if (this.body.classList.contains("cart-drawer-show")) {
					this.close()
				} else {
					this.open()
				}
			})
			
			this.headerCartButton.addEventListener("keydown", (e) => {
				if (e.code.toUpperCase() === "SPACE") {
					e.preventDefault()
					this.open()
				}
			})
		}
		
		if (!this.backdrop.hasAttribute("listened")) {
			this.backdrop.addEventListener("click", (e) => {
				e.preventDefault()
				this.close()
			})
		}
		
		this.headerCartButton.setAttribute("listened", "")
		this.backdrop.setAttribute("listened", "")
	}
	
	initQuantitySelector() {
		const cartItems = this.cart.querySelectorAll(".cart-drawer-item[data-line-item-key]")
		
		if (cartItems.length > 0) {
			cartItems.forEach(async cartItem => {
				const input = cartItem.querySelector(".cart-drawer-item_quantity-selector-input")
				const buttons = cartItem.querySelectorAll(".cart-drawer-item_quantity-selector-button")
				const countItem = cartItem.querySelector(".cart-drawer-item_quantity-selector-input")
				const key = cartItem.getAttribute("data-line-item-key")
				
				if (input) {
					input.addEventListener("input", this.debounce(async (e) => {
						let value = e.target.value
						
						if (value !== "") {
							const cartItemId = cartItem.getAttribute("data-line-item-id")
							
							await this.handleQuantityUpdate({ [key]: value }, cartItem)
							this.focusCartItemPriceInput(cartItemId)
						}
					}))
					
					input.addEventListener("input", async (e) => {
						let value = e.target.value
						
						if (Number(value) < 0) {
							input.value = 0
						} else if (Number(value) > 99) {
							input.value = 99
						}
					})
					
					input.addEventListener("keydown", async (e) => {
						if (e.code.toUpperCase() === "ENTER") {
							e.preventDefault()
							let value = e.target.value
							
							if (value === "") {
								value = 0
							}
							
							await this.handleQuantityUpdate({ [key]: value }, cartItem)
						}
					})
				}
				
				if (buttons.length > 0) {
					buttons.forEach(button => {
						const buttonType = button.getAttribute("data-quantity-selector-type")
						
						button.addEventListener("click", async () => {
							let newQuantity
							const currentQuantity = Number(countItem.value)
							
							buttonType === "inc"
								? newQuantity = currentQuantity + 1
								: newQuantity = currentQuantity - 1
							
							if (newQuantity <= 99) {
								const cartDrawerData = { [key]: newQuantity }
								await this.handleQuantityUpdate(cartDrawerData, cartItem)
							}
						})
					})
				}
			})
		}
	}
	
	async handleQuantityUpdate(data, item) {
		const cartPrice = this.cart.querySelector(".cart-drawer_price-count")
		const cartItemPrice = item.querySelector(".cart-drawer-item_price")
		const cartItemPriceInput = item.querySelector(".cart-drawer-item_quantity-selector-input")
		const shippingAssurancePrice = this.shippingAssurance.querySelector(".cart-drawer-item_price")
		
		this.disableCartItemPriceInput(cartItemPriceInput)
		
		this.initLoader(cartPrice)
		this.initLoader(cartItemPrice)
		if (this.shippingAssurance && this.shippingAssuranceEnabled === "true") {
			this.initLoader(shippingAssurancePrice)
		}
		
		await this.updateCartDrawerItem(data)
		await this.updateCartDrawer()
		this.triggerUpdateProductForm()
	}
	
	debounce(func, timeout = 500) {
		let timer
		return (...args) => {
			clearTimeout(timer)
			timer = setTimeout(() => {
				func.apply(this, args)
			}, timeout)
		}
	}
	
	disableCartItemPriceInput(input) {
		input.disabled = true
	}
	
	focusCartItemPriceInput(id) {
		const input = this.cart.querySelector(`.cart-drawer-item[data-line-item-id="${id}"] .cart-drawer-item_quantity-selector-input`)
		input.setSelectionRange(input.value.length, input.value.length)
		input.focus()
	}
	
	initShippingAssurance() {
		this.shippingAssurance = document.querySelector(".cart-drawer-item.shipping-assurance")
		
		if (this.shippingAssurance) {
			const cartPriceElement = this.cart.querySelector(".cart-drawer_price-count")
			const cartPrice = cartPriceElement.getAttribute("data-cart-price")
			const shippingAssuranceSwitcherElement = this.shippingAssurance.querySelector("#shipping-assurance")
			const shippingAssurancePriceElement = this.shippingAssurance.querySelector(".cart-drawer-item_price")
			const shippingAssurancePrice = this.shippingAssurance.getAttribute("data-cart-shipping-assurance-current-variant-price")

			this.getAssuranceEnabled()
			
			if (this.shippingAssuranceEnabled === "true") {
				this.setPriceWithAssurance(shippingAssuranceSwitcherElement, shippingAssurancePriceElement, cartPriceElement, cartPrice, shippingAssurancePrice)
			} else {
				this.setPriceWithoutAssurance(shippingAssuranceSwitcherElement, shippingAssurancePriceElement, cartPriceElement, cartPrice)
			}
			
			shippingAssuranceSwitcherElement.addEventListener("click", async () => {
				if (shippingAssuranceSwitcherElement.checked) {
					this.setAssuranceEnabled("true")
					this.setPriceWithAssurance(shippingAssuranceSwitcherElement, shippingAssurancePriceElement, cartPriceElement, cartPrice, shippingAssurancePrice)
				} else {
					this.setAssuranceEnabled("false")
					this.setPriceWithoutAssurance(shippingAssuranceSwitcherElement, shippingAssurancePriceElement, cartPriceElement, cartPrice)
				}
			})
		}
	}
	
	getAssuranceEnabled() {
		const shippingAssuranceDefault = this.shippingAssurance.getAttribute("data-cart-shipping-assurance-default-enable")
		let shippingAssuranceCurrent = sessionStorage.getItem("shipping-assurance")

		if (shippingAssuranceCurrent === "" || shippingAssuranceCurrent === null) {
			sessionStorage.setItem("shipping-assurance", shippingAssuranceDefault)
			shippingAssuranceCurrent = shippingAssuranceDefault
		}

		this.shippingAssuranceEnabled = shippingAssuranceCurrent
	}
	
	setAssuranceEnabled(status) {
		this.shippingAssuranceEnabled = status
		sessionStorage.setItem("shipping-assurance", this.shippingAssuranceEnabled)
	}
	
	setPriceWithAssurance(switcherElement, assurancePriceElement, cartPricEelment, cartPrice, assurancePrice) {
		switcherElement.checked = true
		assurancePriceElement.style.display = "block"
		cartPricEelment.innerHTML = ((Number(cartPrice) + Number(assurancePrice)) / 100).toLocaleString("en-US", {
			style: "currency",
			currency: "USD"
		})
	}
	
	setPriceWithoutAssurance(switcherElement, assurancePriceElement, cartPricEelment, cartPrice) {
		switcherElement.checked = false
		assurancePriceElement.style.display = "none"
		cartPricEelment.innerHTML = (Number(cartPrice) / 100).toLocaleString("en-US", {
			style: "currency",
			currency: "USD"
		})
	}
	
	async addShippingAssuranceItem() {
		const shippingAssuranceVariant = this.shippingAssurance.getAttribute("data-cart-shipping-assurance-current-variant")
		const data = {
			id: shippingAssuranceVariant,
			quantity: 1
		}
		
		await this.addCartDrawerItem(data)
	}
	
	async removeShippingAssuranceItem(variants) {
		let data = {}
		
		variants.forEach(variant => {
			data[variant] = 0
		})
		
		await fetch("/cart/update.js", {
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ updates: data })
		})
	}
	
	async updateCartItemsCount() {
		const response = await fetch("/cart.js")
		const cart = await response.json()
		
		const headerCart = document.querySelector(".header_nav-cart")
		headerCart.setAttribute("data-counter", cart.item_count)
	}
	
	async addCartDrawerItem(data) {
		await fetch("/cart/add.js", {
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify(data)
		})
	}
	
	async updateCartDrawerItem(data) {
		await fetch("/cart/update.js", {
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ updates: data })
		})
	}
	
	async getUpdatedCartDrawerHtml() {
		const response = await fetch("/?section_id=cart-drawer")
		const textTemplate = await response.text()
		const html = document.createElement("div")
		html.innerHTML = textTemplate
		return html
	}
	
	async updateCartDrawer() {
		const isRemoved = await this.removeOutOfStockCardDrawerItems()
		const html = await this.getUpdatedCartDrawerHtml()
		const updatedCartDrawer = html.querySelector(".cart-drawer")
		this.cart.innerHTML = updatedCartDrawer.innerHTML
		
		this.setCartListeners()
		this.initQuantitySelector()
		this.initShippingAssurance()
		await this.updateCartItemsCount()
		
		if (isRemoved) {
			this.cart.classList.add("removed-out-fo-stock-items")
		}
	}
	
	async removeOutOfStockCardDrawerItems() {
		let isRemoved = false
		this.carDrawerItemsContainer = this.cart.querySelector(".cart-drawer_items")
		
		if (this.carDrawerItemsContainer) {
			this.outOfStockItems = this.carDrawerItemsContainer.getAttribute("data-out-off-stock-items")?.split(",")
			
			if (this.outOfStockItems) {
				const outOfStockItemsData = {}
				this.outOfStockItems.forEach(key => outOfStockItemsData[key] = 0)
				
				await this.updateCartDrawerItem(outOfStockItemsData)
				isRemoved = true
			}
		}
		
		return isRemoved
	}
	
	triggerUpdateProductForm() {
		const productInfoUpdateTrigger = new CustomEvent("product-form-update")
		window.dispatchEvent(productInfoUpdateTrigger)
	}
	
	initLoader(target) {
		target.innerHTML = "<div class='loader'><span class='loader_dot'></span><span class='loader_dot'></span><span class='loader_dot'></span></div>"
	}
	
	open() {
		const screenWidth = window.innerWidth
		
		if (screenWidth < 567) {
			this.body.classList.remove("burger-menu-open", "body-scroll-off")
		}
		
		const drawer = this.cart
		const backdrop = document.querySelector(".backdrop")
		
		drawer.style.visibility = "visible"
		backdrop.style.visibility = "visible"
		this.body.classList.add("cart-drawer-show", "body-scroll-off", "backdrop-show")
		drawer.classList.remove("removed-out-fo-stock-items")
	}
	
	close() {
		if (window.location.hash.includes("cart")) {
			window.location.hash = "cart=close"
		}
		
		this.body.classList.remove("cart-drawer-show", "body-scroll-off", "backdrop-show")
	}
	
	checkOpen() {
		return this.body.classList.contains("cart-drawer-show")
	}
}

customElements.define("cart-drawer", CartDrawer)
